import CONFIG from '../config';
import axios from 'axios';
import { paramsSerializer } from '@/helpers/serializers';

export function chartData(headers) {
  return {
    getChartData(fromTo) {
      const params = !!(fromTo && fromTo.from && fromTo.to) ? paramsSerializer(fromTo) : '';
      return axios
        .get(this.getUrl(CONFIG.endPoints.chart.data + `?${params}`), headers)
        .then(res => res.data);
    },

    getDailyHigh() {
      return axios
        .get(this.getUrl(CONFIG.endPoints.chart.dailyHigh), headers)
        .then(res => res.data);
    },

    getDailyVolume() {
      return axios
        .get(this.getUrl(CONFIG.endPoints.chart.dailyVolume), headers)
        .then(res => res.data);
    },

    getMarketCup() {
      return axios
        .get(this.getUrl(CONFIG.endPoints.chart.marketCup), headers)
        .then(res => res.data);
    },

    getUrl(endPoint) {
      return CONFIG.backendURL + endPoint;
    }
  };
}
